/* tslint:disable: member-ordering */
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import { helpers } from '../../helpers';
import { ALERT_AUTOCLOSE_MS } from '../../constants';

import { ViewActions } from './view.actions';
import { ViewService } from './view.service';
import { AssessmentActions } from '../assessment';

let stopAudio = (audio) => {
  if (!audio) {
    return;
  }

  audio.currentTime = 0;
  audio.pause();
};

@Injectable()
export class ViewEffects {
  constructor(
    private actions$: Actions,
    private viewActions: ViewActions,
    private viewService: ViewService
  ) { }
  @Effect(({ dispatch: false })) playAudio$ = this.actions$
    .ofType(ViewActions.PLAY_AUDIO)
    .map(action => action['payload'])
    .switchMap(audio => {
      // if (this.viewService.audio) {
      //   this.viewService.audio.pause();
      // }
      stopAudio(this.viewService.audio);
      this.viewService.audio = audio;
      audio.play();

      return Observable.empty();
    });

  @Effect(({ dispatch: false })) stopAudio$ = this.actions$
    .ofType(ViewActions.STOP_AUDIO)
    .map(action => action['payload'])
    .switchMap(audio => {
      stopAudio(this.viewService.audio);
      this.viewService.audio = null;
      return Observable.empty();
    });


  @Effect() addedAlert$ = this.actions$
    .ofType(ViewActions.ADD_ALERT)
    .map(action => action['payload'])
    .switchMap(payload => {
      let alert = Object.assign({}, payload);

      if (typeof alert.id === 'undefined') {
          alert.id = helpers.generateShortUID();
      }

      return Observable.of(this.viewActions.insertAlert(alert));
    });

  @Effect() afterAddAlert$ = this.actions$
    .ofType(ViewActions.INSERT_ALERT)
    .map(action => action['payload'])
    .filter(alert => !alert.preventAutoclose)
    .delay(ALERT_AUTOCLOSE_MS)
    .switchMap(alert => {
      return Observable.of(this.viewActions.removeAlert(alert.id));
    });

  @Effect() fullscreenExit$ = this.actions$
    .ofType(ViewActions.SET_FULLSCREEN)
    .map(action => action['payload'])
    .filter(isFullscreen => !isFullscreen)
    .switchMap(() =>
      Observable.merge(
        Observable.of(this.viewActions.closeModal()),
        Observable.of(this.viewActions.audioExtEnded())
      )
    );

  @Effect() changeSection$ = this.actions$
    .ofType(AssessmentActions.START_TEST)
    .switchMap(() =>
      Observable.of(this.viewActions.changeView('survey'))
    );

  @Effect() terminateTest$ = this.actions$
    .ofType(AssessmentActions.TERMINATE_TEST_SUCCESS)
    .switchMap(() => Observable.merge(
      Observable.of(this.viewActions.closeModal()),
      Observable.of(this.viewActions.changeView('report'))
    ));

  @Effect() startTest$ = this.actions$
    .ofType(AssessmentActions.SET_CURRENT_SECTION_ID)
    .switchMap(() =>
      Observable.of(this.viewActions.closeModal())
    );

  @Effect() requestSection$ = Observable.merge(
    this.actions$
      .ofType(AssessmentActions.REQUEST_NEW_SECTION_BEFORE),
    this.actions$
      .ofType(AssessmentActions.REQUEST_TERMINATE_TEST))
    .switchMap(() =>
      Observable.merge(
        Observable.of(this.viewActions.setModalLoading(true)),
        Observable.of(this.viewActions.audioExtEnded())
      )
    );

  @Effect() completeSectionLoading$ = Observable.merge(
    this.actions$
      .ofType(AssessmentActions.REQUEST_NEW_SECTION_SUCCESS),
    this.actions$
      .ofType(AssessmentActions.REQUEST_NEW_SECTION_FAIL),
    this.actions$
      .ofType(AssessmentActions.TERMINATE_TEST_SUCCESS),
    this.actions$
      .ofType(AssessmentActions.TERMINATE_TEST_FAIL))
    .debounceTime(100)
    .switchMap(() =>
      Observable.of(this.viewActions.setModalLoading(false))
    );

  @Effect() changeCurrentQuestion$ = Observable.merge(
    this.actions$
      .ofType(AssessmentActions.SET_CURRENT_QUESTION_ID),
    this.actions$
      .ofType(AssessmentActions.TERMINATE_TEST_SUCCESS),
    this.actions$
      .ofType(ViewActions.CHANGE_VIEW),
    this.actions$
      .ofType(ViewActions.SET_FULLSCREEN)
      .filter(action => action['payload'] === false))
    .switchMap(() => Observable.of(this.viewActions.closeModalImage())
    );

  @Effect() changeCurrentQuestionStopAudio$ = Observable.merge(
    this.actions$
      .ofType(AssessmentActions.TERMINATE_TEST_SUCCESS),
    this.actions$
      .ofType(ViewActions.CHANGE_VIEW),
    this.actions$
      .ofType(ViewActions.SET_FULLSCREEN)
      .filter(action => action['payload'] === false))
    .switchMap(() =>
      Observable.of(this.viewActions.stopAudio())
    );
}



// WEBPACK FOOTER //
// ./src/app/logics/view/view.effects.ts